import React, { FC, useEffect, useState } from 'react';
import { ProaSummaryPresenter } from '@presenters/screens/proa-summary.presenter';
import { AEABatchGrid } from '@/components';
import { Container, Row, Col, Button } from 'reactstrap';
import { IBasicDataConfig } from "@interfaces/screens/basic-data-config.interface";
import { BasicDataPresenter } from '@presenters/screens/basic-data-config.presenter';
import styles from './basic-data-config.module.scss';
import { AEAField } from '@components/';
import { Enums } from '@utils';

export interface IBaseDataConfigsProps {
	summaryPresenter: ProaSummaryPresenter;
	projectsGrouped: any;
};
 
const BaseDataConfig: FC<any> = (props: IBaseDataConfigsProps) => {
	const [dataColumns, setDataColumns] = useState(null);
	const [feTabsProps, setFeTabsProps] = useState(null);
	const [feTabs, setFeTabs] = useState([]);
	const [dataSource, setDataSource] = useState([]);
	const [codesGrouped, setCodesGrouped] = useState(null);
	const [rowSelected, setRowSelected] = useState(null);
	const [codePpal, setCodePpal] = useState(null);

	let view: IBasicDataConfig = {
		state:{
			feTabs: feTabs,
			dataColumns: dataColumns,
			dataSource: dataSource,
			rowSelected:rowSelected,
			setDataColumns:setDataColumns,
			setDataSource:setDataSource,
			setRowSelected: setRowSelected,
			setCodesGrouped: setCodesGrouped,
			setCodePpal:setCodePpal
		}
	};

	let presenter =  new BasicDataPresenter(view);

	useEffect(() => {        
		if(feTabsProps?.tabsArray?.length && presenter.projectsGrouped){
			setFeTabs(feTabsProps.tabsArray)
			presenter.initialize(feTabsProps.tabsArray, presenter.projectsGrouped);
		}
	}, [feTabsProps, presenter.projectsGrouped]);

	useEffect(() => {        
		presenter.consult(); 
	}, []);

	useEffect(() => {
		if(presenter.currentBudgetDetails && presenter.subProjectsInfo && presenter.projectsGrouped){
		  let tabs: any = presenter.getFormFeTabs();
		  setFeTabsProps(tabs)
		}
	}, [presenter.currentBudgetDetails, presenter.subProjectsInfo, presenter.projectsGrouped]);

	return (
		<>
		{dataColumns && !!feTabsProps ?
			<Container fluid={true}>
				<>
					<Row className={styles.toolbarRow} xs="2" sm="3" md="3" lg="3" xl="3">
						<Col className={styles.marginBox}>
							<label>{presenter.currentLabels.get('CodigoPrincipal')}: </label>
							<AEAField
								showLabel={false} 
								showTooltip={false} 
								value={codePpal}
								readOnly={rowSelected ? true : false}
								placeholder={presenter.currentLabels.get("Todos")} 
								onValueChanged={(value) => presenter.onValueChanged(value, feTabs)} 
								fieldType={Enums.FieldTypes.Select} id={"1"}
								items={feTabs?.length ? presenter.getItemsPpal(codesGrouped, dataSource, feTabs, rowSelected) : []}>
							</AEAField>
						</Col>
						<Col className={styles.marginBox}>
							<label>{presenter.currentLabels.get('SubProyectosAgrupados')}: </label>
							<AEAField 
								showLabel={false} 
								showTooltip={false} 
								multiple
								value={codesGrouped || []}
								placeholder={presenter.currentLabels.get("Todos")} 
								onValueChanged={(value) => presenter.onValueChanged(value, feTabs, true)} 
								fieldType={Enums.FieldTypes.Select} id={"2"}
								items={feTabs?.length ? presenter.getItemsGrouped(codePpal, dataSource, feTabs, feTabsProps.tabsEmpty, rowSelected) : []}>
							</AEAField>
						</Col>     
					</Row>
					<Row className={styles.gridRow}>
						<Button className={styles.buttonConfig}
							disabled={(!codePpal || !codesGrouped)}
							onClick={(e) => {
								e.preventDefault();  
								presenter.guardar(codesGrouped,codePpal, dataSource, rowSelected)
							}}>{presenter.currentLabels.get(rowSelected ? 'Guardar' : 'Agregar')}
						</Button>
						{rowSelected ? 
							<Button className={styles.buttonConfig}
								onClick={(e) => {
									presenter.eliminar(dataSource, rowSelected)
								}}>{presenter.currentLabels.get('Eliminar')}
							</Button>
						: null}
						{(codePpal || codesGrouped) ? 
							<Button
								onClick={(e) => {
									presenter.limpiar()
								}}>{presenter.currentLabels.get('Cancelar')}
							</Button>
						: null}
					</Row>
				</>  
				<Row className={styles.gridRow}>
					<AEABatchGrid columns={dataColumns || []}  
						onSelectionChanged={(rowSelected) => {presenter.onRowSelected(rowSelected, feTabs)}} 
						dataSource={dataSource}
						gridProps={presenter.getGridProps()}
						summaryRows={presenter.summaryConfig} ></AEABatchGrid>  
				</Row>
			</Container>	
		: null} 
		</>
	)  
}

export default BaseDataConfig;
